module.exports = __webpack_public_path__ + "media/assets/icons/uil_brain-4b756e7aa7b1ae051cdeb03e5172f50d.svg";